// 정규표현식을 사용할 때 오류가 발생할 수 있는 문자를 변경합니다.
const removeInvalidChar = (value: string) =>
  value
    .split('')
    .map((char) =>
      /[\\{\\}\\[\]\\/?.,;:|\\)*~`!^\-+<>@\\#$%&\\\\=\\(\\'\\"]/gi.test(char)
        ? `\\${char}`
        : char,
    )
    .join('');

export default removeInvalidChar;
